import React from 'react';

function Info(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 2C6.47732 2 2 6.47732 2 12C2 17.5227 6.47732 22 12 22C17.5227 22 22 17.5227 22 12C22 6.47732 17.5227 2 12 2ZM12 3.25C16.8323 3.25 20.75 7.16768 20.75 12C20.75 16.8323 16.8323 20.75 12 20.75C7.16768 20.75 3.25 16.8323 3.25 12C3.25 7.16768 7.16768 3.25 12 3.25ZM11.6875 7L11.7968 7.00631C12.263 7.06047 12.625 7.4568 12.625 7.9375C12.625 8.45518 12.2052 8.875 11.6875 8.875C11.1698 8.875 10.75 8.45518 10.75 7.9375C10.75 7.4568 11.112 7.06047 11.5782 7.00631L11.6875 7ZM11.375 10.125C12.022 10.125 12.5545 10.617 12.6185 11.2472L12.625 11.375V14.5C12.625 14.8135 12.8566 15.0735 13.1577 15.1182L13.25 15.125H13.875C14.2202 15.125 14.5 15.4048 14.5 15.75C14.5 16.0638 14.2687 16.3236 13.9674 16.3682L13.875 16.375H13.25C12.2641 16.375 11.4554 15.6133 11.3806 14.6465L11.375 14.5V11.375H10.75C10.4048 11.375 10.125 11.0952 10.125 10.75C10.125 10.4362 10.3563 10.1764 10.6576 10.1318L10.75 10.125H11.375Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Info;
